import $ from 'jquery';
import GaTracking from '../../../core/components/ga-tracking';
const PAGE_SELECTOR = '.js__first-steps-ga-tracking';
const SLIDER_SELECTOR = '.js__first-steps-ga-slider';
const TRACK_SELECTOR = '.js__first-steps-ga-track';
const STEP_PLACEHOLDER = '%step%';
const VIEW_EVENT_LABEL_ATTRIBUTE = 'data-ga-view-event-label';
export default class FirstStepsGaTracking {
    static activeSteps = new WeakMap();
    static states = new WeakMap();
    static init() {
        $(PAGE_SELECTOR).each((_index, root) => {
            const $root = $(root);
            const eventCategory = $root.attr('data-ga-event-category');
            if (!eventCategory) {
                return;
            }
            if (this.states.has(root)) {
                return;
            }
            const state = {
                eventCategory,
            };
            this.states.set(root, state);
            root.addEventListener('click', event => this.trackClick(state, $root, event), true);
        });
    }
    static trackSlideActivation(activeIndex, $sliderRoot) {
        if (!$sliderRoot.is(SLIDER_SELECTOR)) {
            return;
        }
        const root = $sliderRoot.closest(PAGE_SELECTOR).get(0);
        const state = root ? this.states.get(root) : undefined;
        if (!state) {
            return;
        }
        const slider = $sliderRoot.get(0);
        if (!slider) {
            return;
        }
        const activeStep = activeIndex + 1;
        this.activeSteps.set(slider, activeStep);
        const viewEventLabelTemplate = $sliderRoot.attr(VIEW_EVENT_LABEL_ATTRIBUTE);
        if (!viewEventLabelTemplate) {
            return;
        }
        const viewEventLabel = this.replaceStep(viewEventLabelTemplate, activeStep);
        this.pushDataLayer(state.eventCategory, 'View', viewEventLabel);
    }
    static trackClick(state, $root, event) {
        if (!(event.target instanceof Element)) {
            return;
        }
        const $target = $(event.target);
        const $metadataElement = $target.closest(TRACK_SELECTOR);
        const metadataElement = $metadataElement.get(0);
        if (!metadataElement || !$root.get(0)?.contains(metadataElement)) {
            return;
        }
        const slider = $metadataElement.closest(SLIDER_SELECTOR).get(0);
        if (!slider) {
            return;
        }
        const eventLabelTemplate = $metadataElement.attr('data-ga-event-label');
        if (!eventLabelTemplate) {
            return;
        }
        const activeStep = this.activeSteps.get(slider);
        if (!activeStep) {
            return;
        }
        const eventLabel = this.replaceStep(eventLabelTemplate, activeStep);
        this.pushDataLayer(state.eventCategory, 'Click', eventLabel);
    }
    static replaceStep(eventLabelTemplate, activeStep) {
        return eventLabelTemplate.split(STEP_PLACEHOLDER).join(String(activeStep));
    }
    static pushDataLayer(eventCategory, eventAction, eventLabel) {
        GaTracking.pushDataLayer({
            event: 'custom_market_tracking_datalayer',
            eventCategory,
            eventAction,
            eventLabel,
        });
    }
}
